import { render, staticRenderFns } from "./CurrentMonthPreviousYearConsumptionComparisonWidget.vue?vue&type=template&id=79ce5f5a&scoped=true&lang=pug&"
import script from "./CurrentMonthPreviousYearConsumptionComparisonWidget.vue?vue&type=script&lang=ts&"
export * from "./CurrentMonthPreviousYearConsumptionComparisonWidget.vue?vue&type=script&lang=ts&"
import style0 from "./CurrentMonthPreviousYearConsumptionComparisonWidget.vue?vue&type=style&index=0&id=79ce5f5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ce5f5a",
  null
  
)

export default component.exports